import i18n from 'i18next';

export const getTranslation = (key: string): string | string[] => {
    // @ts-ignore
    const translation = i18n.t(key, { returnObjects: true });
    if (typeof translation === 'string' || Array.isArray(translation)) {
        return translation;
    }
    throw new Error(`Translation for key "${key}" is not a string or an array.`);
};
